<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="经销商编号">
            <a-input v-decorator="['dealerNo', rules.dealerNo]"/>
          </a-form-item>
        </a-col>

      </a-row>

    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>

</template>

<script>
import {formMixin} from '@/utils/common/FormBase'
//接口API
import {dataApi} from '@/services/comm/dealerManage';


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    dealerNo: {
      rules: [{required: true, whitespace: true, message: "请输入经销商编号"}]
    },
  };
}
/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {

  }
}

/**
 * 加载基础数据
 */
async function loadBaseData() {}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  console.log(rowId);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities) {
  return await dataApi.saveFormDetail(this.dealerId,entities.dealerNo);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
  },
  props: {
    dealerId: {
      type: Number,
    },
  },
  data() {
    return {


    }
  },
  mounted() {
  },
  methods: {
    save,
    loadEntity,
    newEntity,
    loadBaseData,
    getRulesTemplate,

  },
};
</script>

<style scoped lang="less">
</style>
